// Could be replaced with an API call
const companies = {
  DUN: {
    ID: process.env.REACT_APP_COMP_DUN,
    Name: 'Dunlopillo Deutschland GmbH'
  },
  EMM: {
    ID: process.env.REACT_APP_COMP_EMM,
    Name: 'Emma Matratzen GmbH'
  }
};

export const VendorToCompanyID = (currentVendor) => BadgeTextToID(currentVendor.companyBadgeText);

export const BadgeTextToID = (badgeText) =>
  companies[badgeText] ? companies[badgeText].ID : process.env.REACT_APP_COMP_EMM;

export const VendorToCompanyFullName = (currentVendor) =>
  BadgeTextToName(currentVendor.companyBadgeText);

export const BadgeTextToName = (badgeText) =>
  companies[badgeText] ? companies[badgeText].Name : companies.EMM.Name;

export const UniqueCompanyIDs = (vendors) => {
  const ids = [];

  vendors.forEach((v) => ids.push(BadgeTextToID(v.name || v.companyBadgeText)));

  return new Set(ids);
};

export const AllCompanyIDs = [companies.DUN.ID, companies.EMM.ID];
